<template>
  <v-list-item :class="{ 'step-added': isAdded }" @click="$emit('click')">
    <v-list-item-content>
      <v-list-item-title>
        <span v-if="!firstWordBold" class="body-1 grey--text text--darken-3">
          {{ idx() }} {{ title }}
        </span>
        <div v-if="firstWordBold">
          <b> {{ idx() }} {{ title.split(" ")[0] }} </b>
          <span class="body-1 grey--text text--darken-3">
            {{ title.split(" ").slice(1).join(" ") }}
          </span>
        </div>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-icon class="align-self-center">
      <v-icon v-if="isAdded" color="success">check_circle</v-icon>
      <v-icon v-else>open_in_new</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  props: {
    isAdded: {
      type: Boolean,
      default: false,
    },
    index: {
      type: [String, Number],
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    firstWordBold: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    idx() {
      if (this.index === null) {
        return "";
      }

      return this.index + " -";
    },
  },
};
</script>

<style scoped>
.step-added {
  background-color: #e8f5e9 !important;
  border-left: 4px solid #4caf50 !important;
}

.step-added:hover {
  background-color: #c8e6c9 !important;
}
</style>
